<template>
  <div class="header-container">
    <header-logo></header-logo>
  </div>
</template>

<script>
import HeaderLogo from "./HeaderLogo";
export default {
  name: "Index",
  components: {
    HeaderLogo
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  margin: 20px;
}
</style>
